export default class LegendItem {
    iconCSS: any;
    text: string;
    min: number;
    max: number; 

    constructor() {
        this.iconCSS = {
            width: "15px",
            height: "15px",
            display: 'inline-block',
            backgroundColor: '', // RGBA (?,?,?,?) determined by color series 
            border: '1px solid #000',
            borderRadius: '15px',
            position: 'relative',
            top:'2px',
        };
        this.text = '';
        this.min = 0;
        this.max = 0;
    }
}